import { Backdrop, Flex, Image, ProgressCircle, Text } from 'components'

export default function EventLoading() {
  return (
    <Backdrop
      width="100%"
      flexDirection="column"
      justifyContent="space-between"
      alignItems="center"
      mt="20vh"
      mb={12}
    >
      <Flex flexDirection="column" alignItems="center" gap={12}>
        <Text textStyle="bodyLarge">Loading Event Details</Text>
        <ProgressCircle colorPalette="white" isIndeterminate />
      </Flex>
      <Image height="30px" src="common/momentify-logo-light.svg" alt="Momentify Logo" />
    </Backdrop>
  )
}
